import { render } from "./B2CLogin.vue?vue&type=template&id=58cb987e&scoped=true"
import script from "./B2CLogin.vue?vue&type=script&lang=js"
export * from "./B2CLogin.vue?vue&type=script&lang=js"

import "./B2CLogin.vue?vue&type=style&index=0&id=58cb987e&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cb987e"]])

export default __exports__